export class CitySelection {
    constructor(city, onSelectedChange) {
        this.onSelectedChange = onSelectedChange;
        this._selected = false;
        this.id = city.id;
        this.name = city.name;
        this.element = this.createFromTemplate();
        this.replaceValues(this.element);
        this.checkbox = this.findCheckbox(this.element);
        this.changeSelectedOnCheckboxChange(this.checkbox);
    }
    get selected() {
        return this._selected;
    }
    set selected(value) {
        this._selected = value;
        this.checkbox.checked = value;
        this.onSelectedChange(this);
    }
    domElement() {
        return this.element;
    }
    changeSelectedOnCheckboxChange(checkbox) {
        checkbox.addEventListener("change", () => {
            this._selected = checkbox.checked;
            if (this.onSelectedChange) {
                this.onSelectedChange(this);
            }
        });
    }
    findCheckbox(element) {
        const checkbox = element.querySelector("input[type=checkbox]");
        if (checkbox === null) {
            throw new Error("Checkbox not found");
        }
        return checkbox;
    }
    replaceValues(element) {
        element.childNodes.forEach((node) => {
            if (node instanceof HTMLElement) {
                node.innerHTML = node.innerHTML
                    .replace(/%id%/g, this.id)
                    .replace(/%name%/g, this.name);
            }
        });
    }
    createFromTemplate() {
        const template = document.getElementById(CitySelection.templateId);
        return document.importNode(template.content, true);
    }
}
CitySelection.templateId = "city-checkbox-template";
